<template>
    <div>
        <template v-if="type=='text'">
            <span v-for="(item,index) in list" :key="item.id">
                {{item.label}}
                <span v-if="list && list.length-1 > index" style="margin-right:3px">;</span>
            </span>
        </template>
        <template v-else-if="type=='tag'">
            <el-tag v-for="item in list" :key="item.id" style="margin-right:8px">{{item.label}}</el-tag>
        </template>
    </div>
</template>

<script>
export default {
    name: 'v-texts',
    props: {
        type: {
            type: String,
            default: "tag"
        },
        value: {
            type: Array,
            default: () => {
                return []
            },
        },
        dictType: {
            type: [Number, String]
        },
        data: {
            type: Array,
            default: () => {
                return []
            },
        },
        params: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data () {
        return {
            list: [],// 选中值列表
        }
    },
    methods: {
        getDictType () {
            this.$api(this.$FRAMEWORK.dictApi,{
                dictType: this.dictType,
                ...this.params
            }).then( res => {
                if (res && res.length) {
                    this.getList(this.value,res)
                }
            }).catch(e => {
                console.error(e)
            })
        },
        getList (value = [],data = []) {
            value.forEach(it =>{
                let index = data.findIndex(v => v.id == it)
                if ( index !== -1) this.list.push(data[index])
            })
        },
        init () {
            if (this.dictType && this.value && this.value.length) {
                this.getDictType()
            } else if(this.value && this.value.length && this.data && this.data.length){
                this.getList(this.value,this.data)
            }
        }
    },
    watch: {
        value (val) {
            if (val) this.init()
        }
    },
    mounted () {
        this.init()
    },
    
}
</script>


// WEBPACK FOOTER //
// src/components/framework/widgets/texts.vue